import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { NgxExtendedPdfViewerService, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { PDFViewerStateEnum } from 'src/app/core/enums/pdf-viewer-state-enum';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent {

  @Input() requisitionId?: string;
  @Input() myFileId?: string;
  @Input() token?: string;
  @Input() fileURL?: string;

  @Output() isPDFLoaded = new EventEmitter<any>();

  widthPx = 856;
  spinnerIsShown: boolean = true;
  pdfSrc: string = "";
  showNoDocument: boolean = false;
  constructor(
    private myFileApiService: MyfileApiService,
  ) {
    pdfDefaultOptions.assetsFolder = 'bleeding-edge';
  }

  ngOnInit(): void {
    if (window.innerWidth < 400) {
      this.widthPx = window.innerWidth * 0.9;
    } else if (window.innerWidth < 992) {
      this.widthPx = 400;
    } else if (window.innerWidth < 1200) {
      this.widthPx = 600;
    }
    if (this.fileURL) {
      this.pdfSrc = this.fileURL;
      this.spinnerIsShown = false;
    } else {
      if (this.requisitionId && this.myFileId) {
        if (this.token != undefined) {
          this.myFileApiService.viewMyFileUrl(this.token, this.requisitionId, this.myFileId).subscribe(result => {
            if (result) {
              var blob = new Blob([result.body as Blob], { type: result.headers.get("Content-Type") as string });
              var fileURL = URL.createObjectURL(blob);
              if (fileURL) {
                this.pdfSrc = fileURL
              } else {
                this.showNoDocument = true;
              }
            }
            this.spinnerIsShown = false;
          });
        } else {
          this.isPDFLoaded.emit(PDFViewerStateEnum.Loaded);
          this.myFileApiService.viewMyFile(this.requisitionId, this.myFileId).subscribe(result => {
            if (result) {
              var fileURL = URL.createObjectURL(result);
              if (fileURL) {
                this.pdfSrc = fileURL
                this.isPDFLoaded.emit(PDFViewerStateEnum.Loaded);
              } else {
                this.showNoDocument = true;
                this.isPDFLoaded.emit(PDFViewerStateEnum.NoPDF);
              }
            }
            this.isPDFLoaded.emit(PDFViewerStateEnum.Failed);
            this.spinnerIsShown = false;
          });
        }
      } else {
        this.spinnerIsShown = false;
      }
    }


  }

}
